import ContentsTypes from "@shared/enums/contentsTypes";
import SolutionCardPreview from "@project/components/SolutionCard/SolutionCardPreview";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
export const SolutionCard = {
    label: "Solution type organisation",
    type: ContentsCustomTypes.SOLUTION_TYPE_ORGANISATION,
    Preview: SolutionCardPreview,
    editionModal: true,
    icon: "address-card",
    editionModalPosition: "top",
    children: [
        {
            label: "Label",
            key: "label",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Question",
            key: "question",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Réponse",
            key: "description",
            type: ContentsTypes.SHORT_TEXT,
            value: "",
        },
        {
            label: "Lien de la carte",
            key: "buttonLink",
            type: ContentsTypes.LINK,
            value: "",
        },
        {
            label: "Couleur de la barre",
            key: "barColor",
            type: ContentsTypes.COLOR,
            value: "#0CFFC6",
        },
    ],
};
